const ContractComponent = () => import('@/views/finance/Contract/ContractView')

export default [
    {
        path:'/ContractIndex',
        name:'ContractComponent',
        component:ContractComponent
    }
]